import { useEffect, useState } from 'react';

// Routeur minimal, volontairement sans bibliotheque : quatre destinations publiques.
// Ajouter un routeur complet pour si peu couterait plus en poids telecharge qu'il ne
// rapporterait.

export type Destination = 'installer' | 'app' | 'confidentialite' | 'demo' | 'reinitialiser';

export const CHEMIN_CONFIDENTIALITE = '/confidentialite';
export const CHEMIN_DEMO = '/demo';
export const CHEMIN_REINITIALISER = '/reinitialiser';

export function destinationDe(chemin: string): Destination {
  // `/app` et ses sous-chemins SEULEMENT : `/application` ne doit pas ouvrir
  // l'application (piege du prefixe commun).
  if (chemin === '/app' || chemin.startsWith('/app/')) return 'app';
  if (chemin === CHEMIN_CONFIDENTIALITE) return 'confidentialite';
  if (chemin === CHEMIN_DEMO) return 'demo';
  if (chemin === CHEMIN_REINITIALISER) return 'reinitialiser';
  return 'installer';
}

const EVENEMENT = 'colette:navigation';

export function naviguer(chemin: string): void {
  if (window.location.pathname === chemin) return;
  window.history.pushState(null, '', chemin);
  window.dispatchEvent(new Event(EVENEMENT));
  // Une navigation doit repartir du haut : sans cela on arrive au milieu d'une page
  // longue, parce que le navigateur conserve la position de la precedente.
  window.scrollTo({ top: 0 });
}

export function useDestination(): Destination {
  const [destination, setDestination] = useState<Destination>(() =>
    destinationDe(window.location.pathname),
  );

  useEffect(() => {
    const relire = () => setDestination(destinationDe(window.location.pathname));
    // `popstate` couvre le bouton retour du navigateur, l'evenement maison couvre nos
    // propres navigations. Sans le premier, le bouton retour laisserait l'ecran fige.
    window.addEventListener('popstate', relire);
    window.addEventListener(EVENEMENT, relire);
    return () => {
      window.removeEventListener('popstate', relire);
      window.removeEventListener(EVENEMENT, relire);
    };
  }, []);

  return destination;
}
